
export const Copyright = () => {
 

  return (
    <div className="copyright" >
        Desarrollado por Cristian Gomez ©
    </div>
  )
}
